export enum AnalyticsEvents {
  Login = 'login',
  SignUp = 'sign_up',
  PageView = 'page_view',

  ForgotPassword = 'forgot_password',
  ResetPassword = 'reset_password',
  ChangePassword = 'change_password',
  UpdateProfile = 'update_profile',
  LinkUser = 'link_user',
}

export interface AnalyticsEventParams extends Record<AnalyticsEvents, Record<string, string | number> | undefined> {
  [AnalyticsEvents.Login]: { method: 'password' | 'google' | 'apple' | 'facebook' | 'code' };
  [AnalyticsEvents.SignUp]: { method?: 'google' | 'apple' | 'facebook' };
  [AnalyticsEvents.PageView]: { page_title: string };
  [AnalyticsEvents.ForgotPassword]: undefined;
  [AnalyticsEvents.ResetPassword]: undefined;
  [AnalyticsEvents.ChangePassword]: undefined;
  [AnalyticsEvents.UpdateProfile]: undefined;
  [AnalyticsEvents.LinkUser]: { provider: 'google' | 'apple' | 'facebook' };
}
